import InventoryProductModel from '../../models/Inventory/InventoryProductModel';
import BaseStore from '../BaseStore';

class InventoryProductStore extends BaseStore {
  constructor(transportLayer) {
    super(InventoryProductModel, transportLayer);
  }

  fetchProductById(id) {
    return this.transportLayer.fetchById(id)
  }

  _removeRelatedFile(productId, fileId) {
    return this.transportLayer.relatedFile.remove(productId, fileId);
  }

  _removeRelatedFileMultiple(productId, fileIds) {
    return this.transportLayer.relatedFile.removeMultiple(productId, fileIds);
  }

  removeRelatedFiles(productId, fileIds) {
    if (typeof fileIds === 'number' || typeof fileIds === 'string') {
      return this._removeRelatedFile(productId, fileIds);
    }
    return this._removeRelatedFileMultiple(productId, fileIds);
  }

  imageRemove(productId, fileId) {
    return this.transportLayer.image.remove(productId, fileId)
  }

}

export default InventoryProductStore;



// WEBPACK FOOTER //
// ./src/stores/Inventory/InventoryProductStore.js